import { fonts } from "../../../../../config";
import { css } from "@linaria/core";

export const LIST_TRANSITION_DURATION = 200;
export const ERROR_TRANSITION_DURATION_MS = 200;

export const portalsCls = css`
  max-width: 980px;
  margin: 5px auto 0;
  padding: 0 30px;

  --font-px: 1px;
  --font-family: ${fonts.figtree};
  --color-primary: #ea7e00;
`;

export const transitionCls = css`
  &-enter {
    opacity: 0;
    transition: opacity ${ERROR_TRANSITION_DURATION_MS}ms linear;
  }

  &-enter-active {
    opacity: 1;
  }

  &-exit {
    display: none;
  }
`;

export const listCls = css`
  list-style-type: none;
  padding: 0;

  /** Render as many portals as possible on one row, but don't allow a single
   * portal to be smaller than 230px (with 20px margin) */
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));

  /** Allow left-most and right-most items to fill to the end of the container
   * by effectively negating their margin used to create spacing between each
   * other */
  margin: 38px -10px 0;

  &-enter {
    opacity: 0;
    transition: opacity ${LIST_TRANSITION_DURATION}ms linear;
  }

  &-enter-active {
    opacity: 1;
  }

  &-exit {
    display: none;
  }
`;
